import { render, staticRenderFns } from "./CatalogListView.vue?vue&type=template&id=61be9f3e"
import script from "./CatalogListView.vue?vue&type=script&lang=js"
export * from "./CatalogListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports